import React, { useContext, useEffect } from "react";

import { router } from "../../../../routes";
import { SocketContext } from "../../../common/context/quoteFormConnector";
import { LandingContext } from "../../../products/context/landing";
import { useQuoteFormState } from "../../state";
import { IResponseQuoteForm } from "../../types";

const responseSaveFormQuote = (response: IResponseQuoteForm) => {
  if (response.isCompleted && response.status) {
    const { Router } = router;
    const { business, filterBy } = Router.router.query;
    Router.pushRoute("results", { business, formId: response.form.id, filterBy });
  }
};

const RequoteForm: React.FC = ({ children }) => {
  const { formId } = useContext(LandingContext);
  const { requoteForm } = useContext(SocketContext);
  const [shouldRequoteForm] = useQuoteFormState("requoteForm");

  useEffect(() => {
    if (shouldRequoteForm) {
      requoteForm(formId!, responseSaveFormQuote);
    }
  }, [shouldRequoteForm, formId]);

  return <>{children}</>;
};

export { RequoteForm };
